import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-newpre-incubator',
  templateUrl: './newpre-incubator.component.html',
  styleUrls: ['./newpre-incubator.component.css'],
})
export class NewpreIncubatorComponent implements OnInit {
  partnerregisterForm: FormGroup;
  private registerApi = environment.url + environment.register;
  /**
   * Creates a new instance of the NewpreIncubatorComponent.
   *
   * The constructor is responsible for initializing the component's
   * properties and setting up the form that is used to register a new
   * pre-incubate.
   *
   * @param router Angular router service
   * @param fb Angular form builder service
   * @param makeapi API service
   * @param getdata Service that exposes application state
   * @param notify Service that provides toast notifications
   */
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService
  ) {
    /**
     * Form group for the pre-incubate registration form.
     *
     * The form has four fields: name, phone, email, and roleid.
     *
     * name: The name of the pre-incubate.
     * phone: The phone number of the pre-incubate.
     * email: The email address of the pre-incubate.
     * roleid: The roleid of the pre-incubate (6 for pre-incubate).
     */
    this.partnerregisterForm = this.fb.group({
      name: ['', [Validators.required]],
      phone: [
        '',
        [
          Validators.required,
          Validators.pattern('^((\\+91-?)|0)?[0-9]{10,10}$'),
        ],
      ],
      email: ['', [Validators.required, Validators.email]],
      roleid: [6],
    });
  }
  get add() {
    return this.partnerregisterForm.controls;
  }
  /**
   * Called when the component is initialized.
   *
   * It sets the visibility of the ValueService to true and calls the
   * checkRegistrationStatus method to check if the registration is closed.
   */
  ngOnInit(): void {
    this.getdata.isVisibleSource.next(true);
    this.checkRegistrationStatus();
  }
  isRegistrationClosedPre: boolean = false;
  /**
   * Checks if the registration is closed.
   *
   * This function compares the current date and time with a fixed deadline.
   * If the current date and time is after the deadline, it sets the
   * isRegistrationClosedPre flag to true, indicating that registration is closed.
   */
  checkRegistrationStatus() {
    // Define the deadline as March 7, 2025, 5:01 PM
    const deadline = new Date(2026, 2, 31, 23, 59, 0);

    // Get the current date and time
    const now = new Date();

    // Check if the current date and time is after the deadline
    this.isRegistrationClosedPre = now >= deadline;
  }
  /**
   * Handles the registration of a partner admin.
   *
   * This function validates the registration form and submits the data to the server.
   * If the form is invalid, it displays an error notification. If the registration is
   * successful, it shows a success modal; otherwise, it displays an error notification.
   */
  registerpartnerAdmin() {
    // Retrieve form values
    let getform = this.partnerregisterForm.value;

    // Check if the form is invalid
    if (this.partnerregisterForm.invalid) {
      // Mark all fields as touched to trigger validation messages
      this.partnerregisterForm.markAllAsTouched();
      // Notify the user to fill in the mandatory fields
      this.notify.notifyError('Please fill all the mandatory fields !!');
      return;
    } else {
      // Show a loading indicator
      this.getdata.amizhthLoader('show');

      // Make an API call to register the partner admin
      this.makeapi
        .method(this.registerApi, getform, 'login')
        .subscribe((data) => {
          // Hide the loading indicator
          this.getdata.amizhthLoader('hide');
          // Check if the registration was successful
          if (data.responseStatus == 'Success') {
            // Display the registration success modal
            document.getElementById('RegisterModal').style.display = 'block';
          } else {
            // Notify the user of the error response
            this.notify.notifyError(data.responseMessage);
          }
        });
    }
  }
  /**
   * Resets the registration form and navigates to the home page.
   *
   * This function is called when the user clicks on the "Cancel" button.
   */
  cancelReg(): void {
    // Reset the form
    this.partnerregisterForm.reset();

    // Navigate to the home page
    this.router.navigateByUrl('/home');
  }
  /**
   * Hides the registration modal and navigates to the login page.
   *
   * This function is called when the user clicks on the "Cancel" button
   * or closes the modal window.
   */
  closeModal(): void {
    // Navigate to the login page
    this.router.navigateByUrl('/login');

    // Hide the registration modal
    document.getElementById('RegisterModal').style.display = 'none';
  }
}
